
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class PhotoPlayer extends Vue {
  @Prop() frames: HTMLImageElement[] | undefined;
  
  show = false;
  public frameIdx = 0;
  public timer: number | undefined;

  public totFrames = 0;
  public interval = 4000;

  mounted() {
    // console.log("PhotoPlayer mounted" + this.$store.state.mainState + " " + this.$store.state.ingenieriaState )
    this.frameIdx = -1;

    this.show = true;
    this.animateSeq();

  }

  onClose() {
    this.$emit('close-player');
  }

  beforeDestroy() {
    this.show = false;
    clearTimeout(this.timer)
  }

  animateSeq() {
    if (!this.frames || this.frames.length === 0) return;

    this.frameIdx = this.frameIdx < this.frames.length - 1 ? this.frameIdx + 1 : 0;
    if (this.frames.length > 1)
      this.timer = setTimeout(this.animateSeq, this.interval);
  }

  get getSource() {
    if (!this.frames || this.frames.length === 0) return null;
    return this.frames[this.frameIdx].src;
  }

  get showProgress() {
    return this.frames && this.frames.length > 1;
  }

  get progressText() {
    if (!this.showProgress)
      return "";
    return `${this.frameIdx + 1} / ${this.frames?.length}`;
  }

  get getFrame() {
    return this.frameIdx;
  }

}

